<script setup lang="ts">
const props = defineProps<{
  mode: 'open' | 'close'
  showContentOption: boolean
}>()

const searchMode = defineModel<boolean>('searchMode', { default: false })

const searchTerm = useRouteQuery<string>('q', '')

const { open } = useReadingView('journal-view-stack')
const hasLicense = useHasContentLicense()

const openLabel = computed(() => props.showContentOption ? 'Åpne innhold og søk' : 'Åpne søk')

const gatedDescriptionId = computed(() => `journal-mobile-search-gated-${props.mode}`)

// Single-section articles have no TOC. Keep search open so the TOC view is never empty
function onSearchInput(value: string) {
  if (!hasLicense.value) {
    return
  }
  searchMode.value = !!value || !props.showContentOption
}

function onSearchSubmit() {
  if (!hasLicense.value) {
    return
  }
  const trimmed = searchTerm.value.trim()
  searchMode.value = !!trimmed || !props.showContentOption
  if (trimmed) {
    open('toc')
  }
}

function onSearchReset() {
  if (!hasLicense.value) {
    return
  }
  searchTerm.value = ''
  searchMode.value = !props.showContentOption
}
</script>

<template>
  <ReadingMobileTableOfContentBar :mode="mode" view-key="journal-view-stack" :open-label="openLabel">
    <form role="search" class="flex-1" @submit.prevent="onSearchSubmit">
      <FormSearchInput
        :id="`journal-mobile-search-${mode}`"
        v-model="searchTerm"
        class="w-full"
        shape="square"
        size="medium"
        name="q-mobile"
        color="carbon"
        label="Søk i denne artikkelen"
        :placeholder="hasLicense ? 'Søk i denne artikkelen' : 'Krever abonnement'"
        :disabled="!hasLicense"
        :aria-describedby="!hasLicense ? gatedDescriptionId : undefined"
        resettable
        @reset="onSearchReset"
        @update:model-value="onSearchInput"
      />
      <span v-if="!hasLicense" :id="gatedDescriptionId" class="sr-only">
        Søk krever abonnement
      </span>
    </form>
  </ReadingMobileTableOfContentBar>
</template>